import { useState } from "react";

type storageTypes = "sessionStorage" | "localStorage";

export const LOCAL_STORAGE = "localStorage";
export const SESSION_STORAGE = "sessionStorage";

export const useWindowStorage = <T = any>(
  keyName: string,
  defaultValue: T,
  storageType: storageTypes = LOCAL_STORAGE,
) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window[storageType].getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else if (defaultValue !== undefined) {
        window[storageType].setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue: T) => {
    try {
      window[storageType].setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    setStoredValue(newValue);
  };

  const deleteItem = () => {
    window[storageType].removeItem(keyName);
    setStoredValue(undefined);
  };

  return [storedValue, setValue, deleteItem] as [T, typeof setValue, typeof deleteItem];
};
